"use strict";

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Route = /*#__PURE__*/function () {
  function Route(connection) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Route);

    if (!path) path = "";else if (path.charAt(0) !== "/") path = "/".concat(path);
    this._connection = connection;
    this._path = path;
    this._headers = headers;
  }

  _createClass(Route, [{
    key: "route",
    value: function route(path, headers) {
      if (!path) path = "";else if (path.charAt(0) !== "/") path = "/".concat(path);
      return new Route(this._connection, this._path + path, Object.assign({}, this._headers, headers));
    }
  }, {
    key: "request",
    value: function request(_a) {
      var method = _a.method,
          path = _a.path,
          _a$headers = _a.headers,
          headers = _a$headers === void 0 ? {} : _a$headers,
          opts = __rest(_a, ["method", "path", "headers"]);

      if (!path) opts.path = "";else if (this._path && path.charAt(0) !== "/") opts.path = "/".concat(path);else opts.path = path;
      opts.basePath = this._path;
      opts.headers = Object.assign({}, this._headers, headers);
      opts.method = method ? method.toUpperCase() : "GET";
      return this._connection.request(opts);
    }
  }, {
    key: "_request1",
    value: function _request1(method) {
      var path = "";
      var qs;
      var headers;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (args[0] === undefined || typeof args[0] === "string") {
        path = args.shift();
      }

      if (args[0] === undefined || typeof args[0] === "object") {
        qs = args.shift();
      }

      if (args[0] === undefined || typeof args[0] === "object") {
        headers = args.shift();
      }

      return this.request({
        method: method,
        path: path,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "_request2",
    value: function _request2(method) {
      var path = "";
      var body = undefined;
      var qs;
      var headers;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (args[0] === undefined || typeof args[0] === "string") {
        path = args.shift();
      }

      body = args.shift();

      if (args[0] === undefined || typeof args[0] === "object") {
        qs = args.shift();
      }

      if (args[0] === undefined || typeof args[0] === "object") {
        headers = args.shift();
      }

      return this.request({
        method: method,
        path: path,
        body: body,
        qs: qs,
        headers: headers
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this._request1.apply(this, ["DELETE"].concat(args));
    }
  }, {
    key: "get",
    value: function get() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this._request1.apply(this, ["GET"].concat(args));
    }
  }, {
    key: "head",
    value: function head() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this._request1.apply(this, ["HEAD"].concat(args));
    }
  }, {
    key: "patch",
    value: function patch() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this._request2.apply(this, ["PATCH"].concat(args));
    }
  }, {
    key: "post",
    value: function post() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this._request2.apply(this, ["POST"].concat(args));
    }
  }, {
    key: "put",
    value: function put() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      return this._request2.apply(this, ["PUT"].concat(args));
    }
  }]);

  return Route;
}();

exports.Route = Route;